import Block from './block';

export default {
	component: Block,
	getChildren(props) { return [].concat(props.content, props.sections); }
};

